import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";

import { DocumentSuggestions, focusAtInputEnd } from "widgets/others";
import { parseNumber, formatNumber } from "widgets/inputs";

import { Base } from "../base";
import { Number as NumberReadonly } from "../../renderers/number";

import style from "./number.css";

export function Number(props) {
  const { column, value, pos, suggestionList } = props;
  const baseRef = useRef(null);
  const inputRef = useRef(null);
  const suggestionRef = useRef(null);
  const [currentValue, setCurrentValue] = useState(value);
  const [readOnly, setReadOnly] = useState(true);
  const decimalPoint =
    column && column.modelConfig && column.modelConfig.Decimalpoint
      ? column.modelConfig.Decimalpoint
      : null;
  useEffect(
    function onValueChange() {
      let num = formatNumber(parseFloat(value), decimalPoint);
      setCurrentValue(num);
      setReadOnly(true);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [value, pos]
  );

  return (
    <Base
      {...props}
      ref={baseRef}
      onEditing={(value) => {
        setReadOnly(false);
        setTimeout(() => {
          if (value !== null && value !== undefined) {
            setCurrentValue(value);
            baseRef.current.dataChanged(parseNumber(value));
          }
          // inputRef.current.focus();
          focusAtInputEnd(inputRef.current);
          suggestionRef.current?.show();
        });
      }}
      type="number"
      doubleClickToEdit={true}
    >
      {(column.readOnly || readOnly) && (
        <NumberReadonly value={currentValue} column={column} />
      )}
      {!readOnly && !column.readOnly && (
        <input
          value={currentValue}
          ref={inputRef}
          className={`${style.input} base`}
          onInput={(e) => {
            setCurrentValue(e.target.value);
            baseRef.current.dataChanged(parseNumber(e.target.value));
          }}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              baseRef.current.dataCompleted();
              baseRef.current.moveNextLine();
            }
            if (e.key === "Escape") {
              baseRef.current.dataChanged(parseNumber(value));
              baseRef.current.dataCompleted();
            }
            if (e.key === "Tab") {
              baseRef.current.dataCompleted();
              e.preventDefault();
              if (e.shiftKey) {
                baseRef.current.movePrevious();
              } else {
                baseRef.current.moveNext();
              }
            }
            suggestionRef.current?.onKeyDown(e, column, false);
            e.stopPropagation();
          }}
          onBlur={() => {
            baseRef.current.dataCompleted();
          }}
        />
      )}
      {!readOnly && !column.readOnly && suggestionList?.length > 0 && (
        <DocumentSuggestions
          ref={suggestionRef}
          onSelect={(value) => {
            setCurrentValue(value);
            baseRef.current.dataChanged(value);
          }}
          suggestionList={suggestionList}
        />
      )}
    </Base>
  );
}

Number.propTypes = {
  value: PropTypes.any,
  column: PropTypes.any,
  row: PropTypes.any,
  suggestionList: PropTypes.array,
  pos: PropTypes.any
};
